
import React from 'react';
import { HeroButtons } from './hero/HeroButtons';
import { FeaturesGrid } from './hero/FeaturesGrid';
import { NeuralBackground } from './hero/NeuralBackground';
import { SynapticText } from './hero/SynapticText';


export const Hero = () => {
  return (
    <>
      {/* Neural Network Hero Section */}
      <header className="relative min-h-screen flex items-center justify-center overflow-hidden">
        
        {/* Neural Network Background */}
        <NeuralBackground />
        
        
        {/* Neural Content Container */}
        <div className="relative z-10 max-w-6xl mx-auto mobile-px-safe sm:px-6 lg:px-8 flex items-center justify-center min-h-screen">
          <div className="text-center space-y-8 sm:space-y-16">
            
            {/* Neural Headline with Synaptic Text */}
            <div className="space-y-4 sm:space-y-8">
              <h1 className="heading-display mobile-text-3xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl mb-4 sm:mb-8">
                <div className="block">
                  <SynapticText 
                    text="Too many patients." 
                    delay={500}
                    className="text-foreground"
                    immediate={true}
                  />
                </div>
                <div className="block mt-2 sm:mt-4">
                  <SynapticText 
                    text="Too little time." 
                    delay={2000}
                    className="text-foreground/70"
                    immediate={true}
                  />
                </div>
              </h1>
              
              <div className="text-foreground/80 mobile-text-base sm:text-lg md:text-xl lg:text-2xl max-w-3xl mx-auto leading-relaxed px-4 sm:px-0">
                <SynapticText 
                  text="Focus on care, not clicks - Digital Human® AI with automated intakes, follow‑ups and cognitive screens in under 60 seconds"
                  delay={4000}
                  className="font-mono mobile-text-sm sm:text-base"
                  immediate={true}
                />
              </div>
            </div>
            
            {/* Neural CTA Buttons - Hidden from social media crawlers */}
            <div className="relative bot-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-primary/10 to-accent/10 rounded-3xl blur-2xl animate-pulse"></div>
              <div className="relative z-10">
                <HeroButtons />
              </div>
            </div>
            
            {/* Neural Scroll Indicator */}
            <div className="pt-8 sm:pt-12">
              <div className="inline-flex flex-col items-center gap-3 sm:gap-4 text-muted-foreground/70">
                <div className="inline-flex items-center gap-3 px-4 py-2 bg-primary/10 rounded-full border border-primary/20">
                  <div className="w-2 h-2 bg-primary rounded-full animate-pulse"></div>
                  <span className="mobile-text-xs sm:text-sm font-mono tracking-wider text-cyan-300 uppercase">NEURAL_ACTIVITY.exe</span>
                </div>
                <div className="flex flex-col items-center gap-2">
                  <div className="w-px h-8 sm:h-12 bg-gradient-to-b from-transparent via-primary to-accent animate-pulse"></div>
                  <div className="w-2 h-2 bg-accent rounded-full animate-ping"></div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </header>

    </>
  );
};
